var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _rect2, _polygon, _circle21, _circle22, _rect3, _rect4, _circle23, _circle24, _circle25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReelRadarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 300,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 80,
    r: 40,
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 80,
    r: 40,
    fill: "white",
    stroke: "#333333",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 60,
    r: 8,
    fill: "#333333"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 60,
    r: 8,
    fill: "#333333"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 60,
    r: 8,
    fill: "#333333"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 80,
    r: 8,
    fill: "#333333"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 80,
    r: 8,
    fill: "#333333"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 80,
    r: 8,
    fill: "#333333"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 100,
    r: 8,
    fill: "#333333"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 100,
    r: 8,
    fill: "#333333"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 100,
    r: 8,
    fill: "#333333"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 60,
    r: 8,
    fill: "#333333"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 60,
    r: 8,
    fill: "#333333"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 60,
    r: 8,
    fill: "#333333"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 80,
    r: 8,
    fill: "#333333"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 80,
    r: 8,
    fill: "#333333"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 80,
    r: 8,
    fill: "#333333"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 100,
    r: 8,
    fill: "#333333"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 100,
    r: 8,
    fill: "#333333"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 270,
    cy: 100,
    r: 8,
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 130,
    width: 50,
    height: 40,
    rx: 5,
    fill: "#FF9B54",
    stroke: "#FF7F2A",
    strokeWidth: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "245,150 245,130 275,115 275,165",
    fill: "#FF9B54",
    stroke: "#FF7F2A",
    strokeWidth: 2
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 150,
    r: 15,
    fill: "#FFB380",
    stroke: "#FF7F2A",
    strokeWidth: 2
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 150,
    r: 8,
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 140,
    width: 20,
    height: 20,
    fill: "#FF9B54",
    stroke: "#FF7F2A",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 110,
    width: 90,
    height: 15,
    fill: "#333333",
    opacity: 0.3,
    rx: 3
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#F0F0F0"
    }
  }))), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 210,
    fontFamily: "Arial, sans-serif",
    fontSize: 48,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "url(#textGradient)",
    style: {
      letterSpacing: 2,
      textShadow: "0px 2px 3px rgba(0,0,0,0.3)"
    }
  }, "REEL\u2022RADAR"), /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 240,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    textAnchor: "middle",
    fill: "#F0F0F0",
    style: {
      letterSpacing: 5,
      textShadow: "0px 1px 2px rgba(0,0,0,0.2)"
    }
  }, "UNCOVER FILMS EFFORTLESSLY"), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 115,
    r: 65,
    fill: "none",
    stroke: "#FF9B54",
    strokeWidth: 1,
    opacity: 0.15
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 115,
    r: 80,
    fill: "none",
    stroke: "#FF9B54",
    strokeWidth: 1,
    opacity: 0.1
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 115,
    r: 95,
    fill: "none",
    stroke: "#FF9B54",
    strokeWidth: 1,
    opacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReelRadarLogo);
export default __webpack_public_path__ + "static/media/reelRadarLogo.2cb3cd7abe972c113faa4b0dbebb1ad6.svg";
export { ForwardRef as ReactComponent };